import { IRoute } from "../../../common/helpers/routesMapper";
import { connect } from "react-redux";
import injectIntl from "../../../common/helpers/injectIntl";
import { withTheme } from "styled-components";

import { seo } from "../../../common/helpers/seo";

import { get } from "../../actions/general";

import lazyComponent from "./lazy";

export default {
    component: connect(null, { get })(injectIntl(withTheme(lazyComponent))),
    renderSeo: (store: any, allMessage: { [key: string]: string }, lang: string) => {
        return seo({ title: allMessage["homework"], allMessage, lang });
    },
} satisfies IRoute;
